import { getResolvedRef } from '../../helpers/get-resolved-ref.js';
/** Navigation is cloned and persisted, so keep documentation as plain display metadata. */
export const getTagExternalDocs = (tag) => {
    const documentation = getResolvedRef(tag.externalDocs);
    return documentation ? { url: documentation.url, description: documentation.description } : undefined;
};
